import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import './Home.css';
import WebCounter from "../counter";
import TerminalVisual from "./TerminalVisual";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I'm a passionate DevOps Engineer and Front-End Developer with over 8+ years of experience in the tech industry. My journey in technology has been fueled by curiosity, creativity, and a drive to solve complex problems.'
              <br />
              <br /><b>What <span className="purple">I Do</span></b><br />
                <ul>
                  <br />
                  <li>As a <b>Software Developer</b>: I craft user experiences that are not only functional but also visually appealing. From responsive designs to intuitive interfaces, my focus is always on bridging the gap between aesthetics and usability.</li>
                  <br />
                  <li>As a <b>DevOps Engineer</b>: I thrive on optimizing workflows and ensuring seamless integration between development and operations. I specialize in automating processes, managing cloud infrastructure, and implementing CI/CD pipelines to enhance efficiency and reliability.</li>
                </ul>
              <br />
              <br />
              Why I Love <span className="purple">What I Do </span>&nbsp;
              <br />
              <br />
              Technology is more than a career; it’s a canvas where I blend logic and creativity. Whether debugging code or designing interactive experiences, every day brings a new opportunity to learn, grow, and innovate.
              <br />
              <br />
              Thank you for stopping by! Feel free to explore more about my work and reach out if you'd like to collaborate or just say <b className="purple">hello. </b>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <div className="about-terminal">
              <TerminalVisual />
            </div>
          </Col>
        </Row>
        <WebCounter/>
      </Container>
    </Container>
  );
}
export default Home2;
